import ol from 'openlayers';
import $ from 'jquery';
import icon_schule from '../../images/mapicons/schule.png'
import icon_nv from '../../images/mapicons/nv.png'
import icon_apotheke from '../../images/mapicons/apotheke.png'
import icon_sport from '../../images/mapicons/sport.png'
import icon_spielplatz from '../../images/mapicons/spielplatz.png'
import icon_kindergarten from '../../images/mapicons/kindergarten.png'
import icon_arzt from '../../images/mapicons/arzt.png'
import icon_haltestelle from '../../images/mapicons/haltestelle.png'
import icon_bahn_haltestelle from '../../images/mapicons/bahn_haltestelle.png'

function inframap (mapdiv, bmapType, lpdata, routes, dailyWayId) {
		this.div = mapdiv;
		var backgroundmaplayer = defineBackgroundLayer(bmapType);
		var map;
		
		function defineBackgroundLayer (bmaptype) {
			var projection = ol.proj.get('EPSG:3857');
			var projectionExtent = projection.getExtent();
			var resolutions = [];
			var matrixIds = [];
			var size = ol.extent.getWidth(projectionExtent) / 256;
			for (var z = 0; z < 20; ++z) {
				// generate resolutions and matrixIds arrays for this WMTS
				resolutions[z] = size / Math.pow(2, z);
				matrixIds[z] = z;
			}
			var basemapAtTypeString;
			var bmaptypeUrl;

			switch (bmaptype) {
			  case 'grey':
				  basemapAtTypeString = 'bmapgrau';
				  bmaptypeUrl = 'bmapgrau';
			    break;
			  case 'normal':
				  basemapAtTypeString = 'normal';
				  bmaptypeUrl = 'geolandbasemap';
			    break;
			  default:
				  basemapAtTypeString = 'bmapgrau';
			  	  bmaptypeUrl = 'bmapgrau';
			    break;
			}
			
			var basemapAtLayer = new ol.layer.Tile(
					{
						opacity : 1,

						extent : projectionExtent,
						source : new ol.source.WMTS(
								{
									url : 'https://maps.wien.gv.at/basemap/'+bmaptypeUrl+'/{Style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}.png',
									layer : basemapAtTypeString,
									matrixSet : 'google3857',
									requestEncoding : 'REST',
									format : 'image/jpeg',
									projection : projection,
									tileGrid : new ol.tilegrid.WMTS({
										origin : ol.extent
												.getTopLeft(projectionExtent),
										resolutions : resolutions,
										matrixIds : matrixIds
									}),
									style : 'normal',
									attributions : [ new ol.Attribution(
											{
												html : '<b>Hintergrundkarte:</b> <a href="http://www.basemap.at/" target="_blank">basemap.at<a/> | '
											}) ]
								})
					})
			var mask = new ol.layer.Tile({
				opacity: 0.4,
			    source: new ol.source.TileWMS({
			        url: 'maps?',
			        params: {
			            'LAYERS': 'mobi_ooe:maske_ooe',
			            'VERSION': '1.1.0',
			            'FORMAT': 'image/png',
			            'TILED': true
			        }
			    })
			});

		     var osm = new ol.layer.Tile({
            source: new ol.source.OSM()
          })

			var layers = [osm, basemapAtLayer, mask];
			return layers;
		}
		
		function asAddressBehavior(map, lpdata) {
			
			var shadowStyle = new ol.style.Style({
		        stroke: new ol.style.Stroke({
		          color: [0, 0, 127, 0.15],
		          width: 15
		        }),
		        zIndex: 1
		      });
			
			var pointStyle = new ol.style.Style({
			    image: new ol.style.Circle({

			        fill: new ol.style.Fill({
			          color: '#42f498'
			        }),
			        stroke: new ol.style.Stroke({
			          color: '#1fa35e',
			          width: 7
			        }),
			        radius: 8
			      })
			    })
			
			var lps_current = lpdata.lps.get(lpdata.id);
			var vectorSource;
		      if (typeof lps_current !== "undefined") {
		    	  vectorSource = lps_current.get('layerSource');
		    	  //vectorSource.addFeature( lps_current.get('feature') );
		    	  map.getView().setZoom(7);
		    	  map.getView().setCenter(vectorSource.getFeatures()[0].getGeometry().getCoordinates());
		      } 
		      else {
		    	  if (lpdata.id === "2") {
		    		  vectorSource = lpdata.lps.get("1").get('layerSource');
		    		  map.getView().setZoom(5);
			    	  map.getView().setCenter(vectorSource.getFeatures()[0].getGeometry().getCoordinates()); 
		    	  }
		    	 vectorSource = new ol.source.Vector({
			      }); 
		      }
			
			 

		      var vectorLayer = new ol.layer.Vector({
		        source: vectorSource,
		        style: [shadowStyle, pointStyle],
		        opacity: 0.85
		      });
		      
		      map.addLayer(vectorLayer);
		      
		      // Stuff for searching
//		      var pointSearchStyle = new ol.style.Style({
//				    image: new ol.style.Circle({
//
//				        fill: new ol.style.Fill({
//				          color: '#42f498'
//				        }),
//				        stroke: new ol.style.Stroke({
//				          color: '#1fa35e',
//				          width: 7
//				        }),
//				        radius: 8
//				      })
//				    })
//		      
//		      
//		      var searchMarkerLayer = new ol.layer.Vector({
//			        source: vectorSource,
//			        style: [shadowStyle, pointStyle],
//			        opacity: 0.85
//			      });
//		      
		      //lpdata.lps.off("remove");
//		      lpdata.lps.on("willBeRemovedByMap", function(lpsrm) {
//		    	  if (lpsrm.id === lpdata.id) {
//		    		  var f = lpsrm.get("feature");
//			    	  var s = lpsrm.get("layerSource");
//			    	  s.removeFeature(f);
//		    	  }
//	        	});
		      
		      
		      map.on('click', function(evt) {
		    	  getAddressDataAndAddPointFeature(evt.coordinate, lpdata.lps, lpdata.id, vectorSource, true)
		          
		          
		          //var curr = hashHistory.getCurrentLocation();
		          //hashHistory.replace('/wohnstandorte/1/addressmap/' + transformed_coordinate[0] +'/'+ transformed_coordinate[1]);
		      });
		      
		      enableGeocodeReaction(vectorSource, 'searched', lpdata.id, lpdata.lps);
		      
		}
		
		function asDailyTargetBehavior(map, lpdata, targetid) {
			
			var stroke = new ol.style.Stroke({color: '#39d685', width: 6});
			var fill = new ol.style.Fill({color: 'red'});

			var style = new ol.style.Style({
			    image: new ol.style.RegularShape({
			      fill: fill,
			      stroke: stroke,
			      points: 4,
			      radius: 12,
			      radius2: 0,
			      angle: Math.PI / 4
			    })
			  })
			
			var targetVectorSource = new ol.source.Vector({
		      });
			
			var lps_current = lpdata.lps.get(lpdata.id);
		    	  var xyhome = lps_current.get('xy');
		    	  //vectorSource.addFeature( lps_current.get('feature') );
		    	  map.getView().setZoom(6);
		    	  map.getView().setCenter(ol.proj.transform(xyhome, "EPSG:4326", "EPSG:900913"));
		    	  
		    	  var targetVectorLayer = new ol.layer.Vector({
				        source: targetVectorSource,
				        style: [style],
				        opacity: 1
				      });
				      
				      map.addLayer(targetVectorLayer);
				      map.on('click', function(evt) {
				    	  getAddressDataAndAddPointFeature(evt.coordinate, lpdata.lps.get(lpdata.id).get('dailyTrips'), targetid, targetVectorSource, true)
				          			          
			      });
				      lpdata.misc.get(lpdata.id).off("searched_target");
				      lpdata.misc.get(lpdata.id).on("searched_target", function(lps) {
			        	  var xy = lpdata.misc.get(lpdata.id).get("lastSearchXY");
			        	  xy = [xy.lon, xy.lat]
				          var transformed_coordinate = ol.proj.transform(xy, "EPSG:4326", "EPSG:900913");
				          map.getView().setZoom(11);
				    	  map.getView().setCenter(transformed_coordinate);
//				    	  lps.unset('searchxy', { silent: true})
				    	  getAddressDataAndAddPointFeature(transformed_coordinate, lpdata.lps.get(lpdata.id).get('dailyTrips'), targetid, targetVectorSource, true)

			          })
				      
				      
		}
		
		function asRouteMapBehavior(map, routes) {
			
			var poiSource = new ol.source.Vector({
		      });
			
			var poiTypes = {
			        'Schule': icon_schule, 
			        'Nahversorger': icon_nv,
			        'Apotheke': icon_apotheke, 
			        'Sporteinrichtung': icon_sport,
			        'Spielplatz': icon_spielplatz, 
			        'Kinderbetreuung': icon_kindergarten, 
			        'Arzt': icon_arzt,
			        'Standort': 'abc',
			        'Haltestelle' : icon_haltestelle,
			        'Bahnhaltestelle' : icon_bahn_haltestelle	
			        
			      };
				
			var defaultPoiStyle = new ol.style.Style({
			    image: new ol.style.Circle({

			        fill: new ol.style.Fill({
			          color: '#42f498'
			        }),
			        
			        radius: 8
			      })
			    })
			
			var pointStyleCache = {};
			
			function poiStyleFunction(feature, resolution) {
		        // get the incomeLevel from the feature properties
		        var type = feature.getProperties().name;
		        // if there is no level or its one we don't recognize,
		        // return the default style (in an array!)
		        if (!type || !poiTypes[type]) {
		          return [defaultPoiStyle];
		        }
		        // check the cache and create a new style for the income
		        // level if its not been created before.
		        if (!pointStyleCache[type]) {
		        	if (type === "Standort") {
		        		pointStyleCache[type] = new ol.style.Style({
		    			    image: new ol.style.Circle({

		    			        fill: new ol.style.Fill({
		    			          color: '#42f498'
		    			        }),
		    			        stroke: new ol.style.Stroke({
		    			          color: '#1fa35e',
		    			          width: 7
		    			        }),
		    			        radius: 8
		    			      })
		    			    });
		        	}
		        	else {
		        		var url = poiTypes[type];
			        	pointStyleCache[type] = new ol.style.Style({
			        	  image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
			        		    anchor: [0.5, 46],
			        		    anchorXUnits: 'fraction',
			        		    anchorYUnits: 'pixels',
			        		    opacity: 1,
			        		    scale: 0.35,
			        		    src: url
			        		  }))
			        		});
		        	}
		        	
		        }
		        // at this point, the style for the current level is in the cache
		        // so return it (as an array!)
		        return [pointStyleCache[type]];
		      }
			
			var poisVectorLayer = new ol.layer.Vector({
		        source: poiSource,
		        style: poiStyleFunction,
		        opacity: 1
		      });
			
			for (var key in routes.points) {
				var poi = routes.points[key]
				
				var geom = ol.proj.transform(poi.geom, "EPSG:4326", "EPSG:900913");
				var feature = new ol.Feature({
					  geometry: new ol.geom.Point(geom),
					  name: poi.type
					});
				poiSource.addFeature(feature);
			}
			
			 
			 
			 
			 var routeSource = new ol.source.Vector({
		      }); 
			
			var defaultRouteStyle = new ol.style.Style({
			    stroke: new ol.style.Stroke({
			        color: '#42f498',
			        width: 6
			      })
			    })
			
			var routeTypes = {
//		        'Schule': "#8c0bd7", 
//		        'Nahversorger': "#0bd76b",
//		        'Apotheke': "#429BF4", 
//		        'Sporteinrichtung': '#F44280',
//		        'Spielplatz': '#42F4F4', 
//		        'Kinderbetreuung': '#d30bd7', 
//		        'Arzt': '#57F442'
		      };
			
			var routeStyleCache = {};
			
			function routeStyleFunction(feature, resolution) {
		        // get the incomeLevel from the feature properties
		        var type = feature.getProperties().name;
		        // if there is no level or its one we don't recognize,
		        // return the default style (in an array!)
		        if (!type || !routeTypes[type]) {
		          return [defaultRouteStyle];
		        }
		        // check the cache and create a new style for the income
		        // level if its not been created before.
		        if (!routeStyleCache[type]) {
		        	var color = routeTypes[type];
		        	routeStyleCache[type] = new ol.style.Style({
					    stroke: new ol.style.Stroke({
					        color: color,
					        width: 6
					      })
					    });
		        }
		        // at this point, the style for the current level is in the cache
		        // so return it (as an array!)
		        return [routeStyleCache[type]];
		      }
			
			var routeVectorLayer = new ol.layer.Vector({
		        source: routeSource,
		        style: routeStyleFunction,
		        opacity: 0.85
		      });
			
			for (var key in routes.lines) {
				var route = routes.lines[key]
				
				var geom_wgs84 = new ol.geom.MultiLineString(route.geom)
				var geom = geom_wgs84.transform("EPSG:4326", "EPSG:900913")
				var feature = new ol.Feature({
					  geometry: geom,
					  name: route.type
					});
				routeSource.addFeature(feature);
			}
			
			 map.addLayer(routeVectorLayer);
			 map.addLayer(poisVectorLayer);
			 
			 map.getView().fit(poiSource.getExtent() ,map.getSize());
			
			
			
		}
		
		function getAddressDataAndAddPointFeature(xy, bbobjectColl, id, vectorSource, shouldAddFreshAttr) {
			var coord = xy;
	          var transformed_coordinate = ol.proj.transform(coord, "EPSG:900913", "EPSG:4326");
	          //console.log(transformed_coordinate);
	          $.ajax({
	        	    url: "reversegeocode",
	        	    data: { 
	        	        "x": coord[0], 
	        	        "y": coord[1]
	        	    },
	        	    type: "GET",
	        	    beforeSend: function () {
	        	    	$("body").css("cursor", "progress");
	        	    },
	        	    success: function(response) {
	        	    	addLp(response.name, coord);
	        	    },
	        	    error: function() {
	        	    	addLp("Wohnstandort "+ id , coord);
	        	    },
	        	    complete: function(xhr) {
	        	    	$("body").css("cursor", "default");
	        	    }
	        	});
	          
	          function addLp (name, coord) {
//	        	  if (lpdata.lps.get(lpdata.id)) {
//	        		  var l = lpdata.lps.get(lpdata.id);
//	        		  var f = l.get("feature");
//			    	  var s = l.get("layerSource");
//			    	  s.removeFeature(f);
//	        	  }
	        	  bbobjectColl.remove(bbobjectColl.get(id));
	        	  
	        	  var geom = new ol.geom.Point(coord);
	        	  var feat = new ol.Feature({
	        		    name: id,
	        		    geometry: geom
	        		});
	        	  
	        	  bbobjectColl.add({
		        	  xy : [transformed_coordinate[0], transformed_coordinate[1]],
		        	  id : id,
		        	  name: name,
		        	  feature: feat,
		        	  layerSource: vectorSource
		          });
	        	  
		          
		          if (shouldAddFreshAttr) {
		        	  bbobjectColl.get(id).set('enhancedByWebService', false)
		          }
		          
		          
		          
		          vectorSource.addFeature( feat );
		          
	          }
		}
		
		function enableGeocodeReaction (vectorSourceForPointFeature, bbeventname, id, bbcoll) {
        	lpdata.misc.get(lpdata.id).on(bbeventname, function(lps) {
	        	  var xy = lpdata.misc.get(lpdata.id).get("lastSearchXY");
	        	  xy = [xy.lon, xy.lat]
		          var transformed_coordinate = ol.proj.transform(xy, "EPSG:4326", "EPSG:900913");
		          map.getView().setZoom(11);
		    	  map.getView().setCenter(transformed_coordinate);
//		    	  lps.unset('searchxy', { silent: true})
		    		  getAddressDataAndAddPointFeature(transformed_coordinate, bbcoll, id, vectorSourceForPointFeature, true)

	          })
        } 
		
		this.init = function() {
			var bglayerarray = backgroundmaplayer;
			var maxExtent = [12.683076,47.413508,15.100068,48.901117];
			map = new ol.Map({
				layers : bglayerarray,
				target : this.div,
				view : new ol.View({
					center : ol.proj.transform([ 14.300619, 48.284929 ],'EPSG:4326', 'EPSG:3857'),
					extent: ol.proj.transformExtent(maxExtent, 'EPSG:4326', 'EPSG:900913'),
					zoom : 1,
					minResolution: 0.5971642834779395,
				    maxResolution: 611.49622628141
				})
			});;
			
			if (lpdata && dailyWayId) {
				asDailyTargetBehavior(map, lpdata, dailyWayId)
			}
			else if (lpdata) {
				asAddressBehavior(map, lpdata);
			} else if (routes) {
				asRouteMapBehavior(map, routes);
			}
			
		}
		this.refresh = function() {
			map.updateSize();
		}
}

export default inframap;




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/olmap.js